/* ============================================================
   Product Card (Carousel) — variant pill picker
   Loaded once via {{ 'product-card-carousel.js' | asset_url | script_tag }}
   from snippets/product-card-carousel.liquid.
   Uses event delegation so cards added later (AJAX, swiper init,
   recommendation hydration) work without re-binding.
============================================================ */
(function () {
  'use strict';

  if (window.__cccCardInit) return;
  window.__cccCardInit = true;

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.ccc-card__variant');
    if (!pill) return;
    if (pill.dataset.soldout === 'true') return;

    var card = pill.closest('.js-ccc-card');
    if (!card) return;

    var pills    = card.querySelectorAll('.ccc-card__variant');
    var idInput  = card.querySelector('.js-ccc-variant-input');
    var priceEl  = card.querySelector('.js-ccc-atc-price');
    var labelEl  = card.querySelector('.js-ccc-atc-label');
    var atcBtn   = card.querySelector('.js-ccc-atc');

    pills.forEach(function (p) {
      p.classList.remove('is-active');
      p.setAttribute('aria-checked', 'false');
    });
    pill.classList.add('is-active');
    pill.setAttribute('aria-checked', 'true');

    var available = pill.dataset.variantAvailable === 'true';

    if (idInput) idInput.value = pill.dataset.variantId;
    if (priceEl) priceEl.textContent = pill.dataset.variantPrice || '';
    if (atcBtn) {
      atcBtn.disabled = !available;
      if (labelEl) labelEl.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
    }
  });
})();
